import { render } from "./EditableDataGrid.vue?vue&type=template&id=aa869c6c&ts=true"
import script from "./EditableDataGrid.vue?vue&type=script&lang=ts"
export * from "./EditableDataGrid.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__